import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, TextField } from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import "./NotificationPaginationToolbar.css";

@inject("notificationStore")
@observer
class NotificationPaginationToolbar extends Component {
    state = {
        pageInputValue: "1"
    };

    componentDidMount() {
        this.setState({ pageInputValue: String(this.props.notificationStore.notificationPage) });
    }

    componentDidUpdate() {
        const currentPage = this.props.notificationStore.notificationPage;
        const inputPage = parseInt(this.state.pageInputValue, 10);
        if (inputPage !== currentPage) {
            this.setState({ pageInputValue: String(currentPage) });
        }
    }

    loadPage = (page) => {
        this.props.notificationStore.loadNotificationPage(page);
    };

    handlePreviousPage = () => {
        const { notificationPage } = this.props.notificationStore;
        if (notificationPage > 1) {
            this.loadPage(notificationPage - 1);
        }
    };

    handleNextPage = () => {
        const { notificationShowMore, notificationPage } = this.props.notificationStore;
        if (notificationShowMore) {
            this.loadPage(notificationPage + 1);
        }
    };

    handlePageInputChange = (e) => {
        this.setState({ pageInputValue: e.target.value });
    };

    handlePageInputKeyDown = (e) => {
        if (e.key === "Enter") {
            this.handlePageInputBlur();
        }
    };

    handlePageInputBlur = () => {
        const { pageInputValue } = this.state;
        const pageNum = parseInt(pageInputValue, 10);
        if (!isNaN(pageNum) && pageNum >= 1) {
            this.loadPage(pageNum);
        } else {
            this.setState({ pageInputValue: String(this.props.notificationStore.notificationPage) });
        }
    };

    render() {
        const { notificationPage, notificationShowMore, notificationLoading, notificationsUpdated } = this.props.notificationStore;
        const { pageInputValue } = this.state;

        if (notificationsUpdated.length === 0 && !notificationLoading && notificationPage <= 1) {
            return null;
        }

        const hasPrevious = notificationPage > 1;
        const hasNext = notificationShowMore;

        return (
            <div className="notif-pagination-toolbar">
                <div className="notif-pagination-info">
                    Showing <strong>{notificationsUpdated.length}</strong> notification{notificationsUpdated.length !== 1 ? "s" : ""}
                </div>

                <div className="notif-pagination-controls">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={this.handlePreviousPage}
                        disabled={!hasPrevious || notificationLoading}
                        className="notif-pagination-nav-btn"
                    >
                        <NavigateBeforeIcon fontSize="small" />
                        Prev
                    </Button>

                    <div className="notif-page-selector">
                        <span>Page</span>
                        <TextField
                            value={pageInputValue}
                            onChange={this.handlePageInputChange}
                            onBlur={this.handlePageInputBlur}
                            onKeyDown={this.handlePageInputKeyDown}
                            variant="outlined"
                            size="small"
                            className="notif-page-input"
                            inputProps={{ style: { textAlign: "center", padding: "6px 8px" } }}
                            disabled={notificationLoading}
                        />
                        <span className="notif-total-pages">of {hasNext ? `${notificationPage}+` : notificationPage}</span>
                    </div>

                    <Button
                        variant="contained"
                        size="small"
                        onClick={this.handleNextPage}
                        disabled={!hasNext || notificationLoading}
                        className="notif-pagination-nav-btn notif-pagination-nav-btn-primary"
                    >
                        Next
                        <NavigateNextIcon fontSize="small" />
                    </Button>
                </div>
            </div>
        );
    }
}

export default NotificationPaginationToolbar;
